<template>
    <div>
        <section class="totalizers-container">
            <div class="totalizers-list">
                <totalizer-block
                    :text="translate('total_volume_stored')"
                    :number="
                        formatVolumeStoredTotalizerRow(totalizers.volumeStored, 't')
                    "
                    iconClass="lyra-icon lyra-imoveis"
                    :noIconTotalizer="false"
                />
                <totalizer-block
                    :text="translate('exported_volume')"
                    :number="
                        formatTextTotalizerRow(totalizers.exportedVolume, 't')
                    "
                    iconClass="lyra-icon lyra-volume-vendido"
                    :noIconTotalizer="false"
                />
                <totalizer-block
                    :text="translate('number_of_exports')"
                    :number="
                        formatTextTotalizerRow(totalizers.numberExports)
                    "
                    iconClass="lyra-icon lyra-transfer"
                    :noIconTotalizer="false"
                />
            </div>
        </section>
    </div>
</template>

<script>
import TotalizerBlock from '@/modules/traceability-report/views/components/TotalizerBlock.vue';
import rastreabilidadeExportacaoService from '@/services/RastreabilidadeExportacaoService';
import formatters from '@/utils/formatters';

export default {
    name: 'Totalizers',
    components: { TotalizerBlock },
    data() {
        return {
            totalizers: {
                volumeStored: '-',
                exportedVolume: '-',
                numberExports: '-'
            }
        };
    },
    computed: {},
    mounted() {
        this.getTotalizers();
    },
    methods: {
        translate(key, params = {}) {
            const base =
                'relatorio_rastreabilidade.messages.traceabilityReport';
            return this.$t(`${base}.${key}`, params);
        },
        async getTotalizers() {
            await rastreabilidadeExportacaoService
                .getTotalizers()
                .then(({ data }) => {
                    this.totalizers.volumeStored = data.totalSaldoDisponivelTon;
                    this.totalizers.exportedVolume = data.totalVolumeExportadoTon;
                    this.totalizers.numberExports = data.totalExportacao;
                }).catch(() => this.$notify.warning({
                    message: this.translate('totalizer.error')
                }));

        },
        formatTextTotalizerRow(data, text) {
            if (!data || data === '') {
                return null;
            } else if (data === '-') {
                return data;
            } else {
                const formattedData = formatters.formatNumber(data, 0, this.$i18n.locale);
                return formattedData + (!text ? '' : ' ' + text);
            }
        },
        formatVolumeStoredTotalizerRow(data, text) {
            if (!data || data === '') {
                return null;
            } else if (data === '-') {
                return data;
            } else {
                const formattedData = formatters.formatNumber(data, 3, this.$i18n.locale);
                return formattedData + (!text ? '' : ' ' + text);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.totalizers-container {
    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
    }

    .totalizers-list {
        width: 100%;
        display: grid;
        column-gap: 16px;
        grid-template-columns: 1fr 1fr 1fr;
    }
}
</style>
